






































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import AvatarsRow from "./AvatarsRow.vue";
import { SelectOptionData } from "./Pi/types";

@Component({
  components: {
    AvatarsRow
  }
})
export default class RecurringTargets extends Vue {
  @Prop() targets!: Array<SelectOptionData>

  @Prop() buttonTitle!: string

  @Emit()
  deleteSubscriptionClick() {
    return null
  }
}
